<template>
   <div v-if="row!=null">

      <ddoAlert :errors="errors"/>

      <v-row dense>

         <v-col cols="12">
            <h4>{{ $t('subtitles.properties') }}</h4>
         </v-col>

         <v-col cols="12">
            <v-text-field
               v-model="row.ctc_email"
               :disabled="level.dialogValues.form_disabled" 
               :label="$t('texts._email')"
                  :rules="level.dialogOptions.emailRules"
            ></v-text-field>
         </v-col>
         <v-col cols="6">
            <v-text-field
               v-model="row.ctc_firstname"
               :disabled="level.dialogValues.form_disabled" 
               :label="$t('texts.ctc_firstname')"
            ></v-text-field>
         </v-col>
         <v-col cols="6">
            <v-text-field
               v-model="row.ctc_lastname"
               :disabled="level.dialogValues.form_disabled" 
               :label="$t('texts.ctc_lastname')"
            ></v-text-field>
         </v-col>
         <v-col cols="6">
            <v-text-field
               v-model="row.ctc_organizationname"
               :disabled="level.dialogValues.form_disabled" 
               :label="$t('texts.ctc_organizationname')"
            ></v-text-field>
         </v-col>
         <v-col cols="6">
            <ddoSelect2
               :callbacks="CTTcallbacks"
               ref="mySelectCTT"
               :options="CTToptions"
            >
               <template v-slot:selection="data">
                  <v-chip
                     v-bind="data.attrs"
                     :input-value="data.selected"
                     close
                     @click:close="$refs.mySelectCTT.remove(data.item)"
                  >
                     <span>{{data.item.ctt_name}}</span>
                  </v-chip>
               </template>

               <template v-slot:item="data">
                  <v-list-item-content>
                     <v-list-item-title>{{data.item.ctt_name}}</v-list-item-title>
                  </v-list-item-content>
               </template>
            </ddoSelect2>
         </v-col>
      </v-row>
      <v-row dense>
         <v-col cols="12">
            <h4>{{ $t('subtitles.phones') }}</h4>
         </v-col>
         <v-col cols="6">
            <h5>{{ $t('subtitles.phone_fixed') }}</h5>
            <VuePhoneNumberInput
               v-model="fixed_phone.nationalNumber"
               :default-country-code="fixed_phone.country"
               :label="$t('texts.ctc_phone_fixed_phone')"
               :translations="translations"
               :disabled="level.dialogValues.form_disabled"
               @update="phone_update_fixed"
            />
         </v-col>
         <v-col cols="6">
            <h5>{{ $t('subtitles.phone_cell') }}</h5>
            <VuePhoneNumberInput
               v-model="cell_phone.nationalNumber"
               :default-country-code="cell_phone.country"
               :label="$t('texts.ctc_phone_cell_phone')"
               :translations="translations"
               :disabled="level.dialogValues.form_disabled"
               @update="phone_update_cell"
            />
         </v-col>
      </v-row>
      <v-row dense>
         <v-col cols="12">
            <h4>{{ $t('subtitles.postal_address') }}</h4>
         </v-col>
         <v-col cols="12">
            <v-text-field
               v-model="row.ctc_addr_line1"
               :disabled="level.dialogValues.form_disabled" 
               :label="$t('texts.ctc_addr_line1')"
            ></v-text-field>
            <v-text-field
               v-model="row.ctc_addr_line2"
               :disabled="level.dialogValues.form_disabled" 
               :label="$t('texts.ctc_addr_line2')"
            ></v-text-field>
         </v-col>
         <v-col cols="3">
            <v-text-field
               v-model="row.ctc_addr_zipcode"
               :disabled="level.dialogValues.form_disabled" 
               :label="$t('texts.ctc_addr_zipcode')"
            ></v-text-field>
         </v-col>
         <v-col cols="6">
            <v-text-field
               v-model="row.ctc_addr_city"
               :disabled="level.dialogValues.form_disabled" 
               :label="$t('texts.ctc_addr_city')"
            ></v-text-field>
         </v-col>
         <v-col cols="3">
            <template>
                  {{ $t('texts.ctc_addr_country') }} <vue-country-code
                     @onSelect="onSelectCountry"
                     ref="MyCountrySelect"
                     :disabledFetchingCountry="true"
                     :preferredCountries="['FR','BE','CA','US']"
                     :dropdownOptions="{ disabledDialCode: true }"
                  >
                  </vue-country-code>
            </template>
         </v-col>
      </v-row>
      <v-btn small class="primary" rounded :disabled="level.dialogValues.disable_update" @click="update_row(row)">{{ $t('buttons.update') }}</v-btn>
   </div>
</template>

<script>
import i18n from '@/plugins/i18n.js';
import ddoAlert from '@/components/ddoAlert.vue';
import ddoSelect2 from '@/components/ddoSelect2.vue';
import VueCountryCode from 'vue-country-code-select';
import VuePhoneNumberInput from 'vue-phone-number-input';
import 'vue-phone-number-input/dist/vue-phone-number-input.css';
import { parsePhoneNumberFromString } from 'libphonenumber-js';

export default {
   name: 'TemplateContact',
   components: {
      ddoAlert,
      ddoSelect2,
      VuePhoneNumberInput,
      VueCountryCode,
   },

   props: {
      row: Object,
      level: Object,
      errors: Array,
      flags: Object,
   },

   watch: {
      'row': 'loadOtherInformations',
   },

   data: function () {
      return {
         translations: {},

         empty_phone_record: {
            nationalNumber: null,
            country: null,
         },

         cell_phone: {
            nationalNumber: null,
            country: null,
         },
         fixed_phone: {
            nationalNumber: null,
            country: null,
         },

         CTTcallbacks: {},
         CTToptions: {
            initial: null,
            selected: null,
            required: true,
            disabled: false,
            multiple: false,
            clearable: false,
            item_text: "ctt_name",
            item_value: "ctt_pk",
            item_disabled: "",
            hide_selected: false,
            change_on_remove: true,
            label: i18n.t('texts.ctt_name'),
         },
      }
   },

   created() {
      this.translations = {
         countrySelectorLabel: i18n.t('texts.countrySelectorLabel'),
         countrySelectorError: i18n.t('texts.countrySelectorError'),
         example: i18n.t('texts.example'),
      }
      this.CTTcallbacks.refresh_rows = this.build_select_ctt;
      this.CTTcallbacks.change       = this.change_ctt;
   },

   methods: {

      loadOtherInformations(row,oldRow) {
         this.load_CountrySelect(row);
         //console.log('loadOtherInformations, row='+JSON.stringify(row))

         if ( row.ctc_phone_cell_phone!=null ) {
            let parse = parsePhoneNumberFromString(row.ctc_phone_cell_phone);
            if ( parse ) {
               this.cell_phone = parse;
            }
         } else {
            this.cell_phone = JSON.parse(JSON.stringify(this.empty_phone_record));
         }

         if ( row.ctc_phone_fixed_phone!=null ) {
            let parse = parsePhoneNumberFromString(row.ctc_phone_fixed_phone);
            if ( parse ) {
               this.fixed_phone = parse;
            }
         } else {
            this.fixed_phone = JSON.parse(JSON.stringify(this.empty_phone_record));
         }
         //console.log('loadOtherInformations, AFTER, row='+JSON.stringify(row))
         this.CTToptions.selected = row.ctt_pk;
      },

      load_CountrySelect(row) {
         if ( row.ctc_addr_country_code ) {
            var country = this.$refs.MyCountrySelect.findCountry(row.ctc_addr_country_code);
            this.$refs.MyCountrySelect.choose(country);
         }
      },

      onSelectCountry({name, iso2, dialCode}) {
         this.row.ctc_addr_country_code = iso2;
         this.row.ctc_addr_country = name;
      },

      phone_update_fixed(data) {
         if ( data.isValid ) {
            this.row.ctc_phone_fixed_phone = data.formattedNumber;
         }
      },

      phone_update_cell(data) {
         if ( data.isValid ) {
            this.row.ctc_phone_cell_phone = data.formattedNumber;
         }
      },

      async build_select_ctt(key=null) {
         this.loading = true;
         let { errorinfos, api_response } = await this.$api.getRows(this.$router,'contacttitle');
         this.loading = false;
         return { errorinfos, api_response }
      },

      async change_ctt(value,item=null) {
         this.row.ctt_pk = value;
      },

      async update_row(row) {
         /*
          * The following test checks NULL values but also UNDEFINED value, which is our main goal
          */
         if (null==row.ctc_pk) { row.ctc_pk = null; }

         if ( this.level.callbacks.update_ctc_row ) {
            await this.level.callbacks.update_ctc_row(row);
         }
      },

   },
}
</script>